import { useQuery } from "@tanstack/react-query";
import { fetchLinkSections } from "../services/links";
import { LinkSection } from "../types/Link";
import { QUERY_CONSTANTS } from "../constants/query-constants";
import { useCookieConsent } from "../contexts/CookieConsentContext";

export const useLinkSections = () => {
    const { hasConsented } = useCookieConsent();

    return useQuery<LinkSection[]>({
        queryKey: ["linkSections", hasConsented],
        queryFn: fetchLinkSections,
        staleTime: QUERY_CONSTANTS.STALE_TIME,
        refetchInterval: QUERY_CONSTANTS.REFETCH_INTERVAL,
        enabled: hasConsented,
    });
};
